import Footer from './home/Footer';
import Header from './home/Header';
import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { logout } from '../utils/logout';
import { ImExit } from 'react-icons/im';
import { Navigate, useNavigate } from 'react-router-dom';
import ReusableTabs from '../components/UIElements/ReusableTabs';
import ApplicationRequests from '../components/SuperAdmin/ApplicationRequests';
import OnlineUsers from '../components/SuperAdmin/OnlineUsers';
import OfflineUsers from '../components/SuperAdmin/OfflineUsers';
import { IoPeople } from 'react-icons/io5';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import WifiIcon from '@mui/icons-material/Wifi';
const SuperAdminPage = () => {
  const [ActiveTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const isAdmin = useSelector((state) => state.auth.isAdmin);
  const HistoryTabs = [
    {
      label: 'Application Requests',
      icon: <IoPeople className='size-8 ' />,
      content: <ApplicationRequests />,
    },
    {
      label: 'Online Users',
      icon: <WifiIcon className='size-8 ' />,
      content: <OnlineUsers />,
    },
    {
      label: 'Offline Users',
      icon: <WifiOffIcon className='size-8 ' />,
      content: <OfflineUsers />,
    },
  ].filter(Boolean);
  useEffect(() => {
    setActiveTab(0);
  }, []);
  if (!isAdmin) return <Navigate to='/admin/signin' replace />;
  return (
    <>
      <div className='min-h-screen flex flex-col justify-between '>
        <div className=''>
          <Header />
          <div className='text-center w-full bg-white'>
            <button
              onClick={async () => {
                localStorage.setItem('userName', null);
                await logout();
                navigate('/admin/signin');
              }}
              className='text-left px-4 py-2 text-sm hover:bg-gray-100 text-red-600 flex items-center gap-2  ml-auto'
            >
              <ImExit size={20} className='text-red-600' /> Logout
            </button>
          </div>
          <Box className='p-4'>
            <Box className='bg-blue-50 p-4 rounded-lg'>
              <Typography variant='h6' className='text-blue-700 font-bold'>
                Manage all clients details here
              </Typography>
              <Typography variant='body1' className='text-gray-600'>
                Manage all the users access,licences,SMS etc...
              </Typography>
            </Box>
            <ReusableTabs
              tabs={HistoryTabs}
              variant='scrollable'
              allowScrollButtons={true}
              defaultTab={ActiveTab}
              className='w-full'
            />
          </Box>
        </div>
        <div className='self-end w-full'>
          {' '}
          <Footer />
        </div>
      </div>
    </>
  );
};
export default SuperAdminPage;
